module.exports = __webpack_public_path__ + "img/is_foreigners_allowed.bc63230d.webp";